export default {
    url: 'ces-2025',
    include: ['us'],
};
